import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { Button } from "@/components/ui/Button";
import { CardDescription, CardTitle } from "@/components/ui/Card";
import {
  BellIcon,
  BookmarkIcon,
  BuildingLibraryIcon,
  ChatBubbleLeftIcon,
  HomeModernIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { TrendingUp } from "lucide-react";
import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";
import { useLanguage } from "@/context/LanguageContext";
import { Panel } from "@/components/ui/Panel";

export function PortfolioOverviewCreatePanel() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      management: "Správa portfolia",
      property: "Vaše nemovitost",
      propertyText:
        "Přehled o nájemníkovi, správci, výši nájmu. Vše na jednom místě.",
      taxComparison: "Srovnání daní",
      taxComparisonText:
        "Přidejte transakce pro srovnání skutečné a paušálové daně.",
    },
    en: {
      management: "Portfolio management",
      property: "Your property",
      propertyText:
        "Tenant, manager, and rent overview. Everything in one place.",
      taxComparison: "Tax comparison",
      taxComparisonText:
        "Add transactions to compare actual expenses with the flat-rate tax option.",
    },
  }[language];

  return (
    <Panel>
      <div className="space-y-1">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.management}
        </PortfolioPageSectionBadge>
      </div>

      <div className="mt-4 space-y-2">
        <PortfolioPageInsightItem
          icon={HomeModernIcon}
          title={copy.property}
          text={copy.propertyText}
        />
        <PortfolioPageInsightItem
          icon={BuildingLibraryIcon}
          title={copy.taxComparison}
          text={copy.taxComparisonText}
        />
      </div>
    </Panel>
  );
}
